const revealSecondsSection = ()=>{
	const getSectionReveal = document.getElementById('infoCotanct');
	setTimeout(()=>{
		getSectionReveal?.classList.add('reveal');
	},3500);
}

export { revealSecondsSection }